export default __webpack_public_path__ + "static/media/personalAddress.9e3f848e.svg";